import { connect } from "react-redux";
import { ProductDestinationTitle } from "app/pages/Listing/components/ProductDestinationTitle";

const mapStateToProps = state => {
	return {
		shop: state.shop,
	};
};

export default connect(mapStateToProps)(ProductDestinationTitle);
